document.addEventListener('DOMContentLoaded', function () {
    const tabGroups = document.querySelectorAll('[data-product-tabs]');

    if (tabGroups.length === 0) return;

    tabGroups.forEach(function (group) {
        const tabs = Array.from(group.querySelectorAll('[data-product-tab]'));
        const panels = Array.from(group.querySelectorAll('[data-product-panel]'));

        tabs.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                tabs.forEach(function (item) {
                    item.classList.remove('is-active');
                    item.setAttribute('aria-selected', 'false');
                });

                panels.forEach(function (panel) {
                    panel.classList.remove('is-active');
                    panel.hidden = true;
                });

                tab.classList.add('is-active');
                tab.setAttribute('aria-selected', 'true');

                if (panels[index]) {
                    panels[index].classList.add('is-active');
                    panels[index].hidden = false;

                    panels[index].dispatchEvent(new CustomEvent('productTabPanelShown', {
                        bubbles: true,
                    }));
                }
            });
        });
    });
});
